// extracted by mini-css-extract-plugin
export default {"hiddenGroup":"HiddenGroup_hiddenGroup__FxE1P","toggle":"HiddenGroup_toggle__uydEZ","isVisibleToggle":"HiddenGroup_isVisibleToggle__PLiYH","content":"HiddenGroup_content__917Pl"};